import { MasterDetail } from "devextreme-react/data-grid";
import React, { useCallback, useMemo } from "react";
import { esmdRoundSubmittedCellRender } from "./esmd-round-submitted-cell-render";
import { useDispatch, useSelector } from "react-redux";
import MdaeDataGrid, {
  IMdaeDataGridProps,
} from "../../common_widgets/data-grid";
import ExcelJS from "exceljs";
import FileSaver from "file-saver";
import AuditPropertiesSection from "./esmd-submission-details";
import { cloneDeep, isEqual } from "lodash";
import { format } from "date-fns";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import { actions as asyncActions } from "async-ops";
import DataGrid from "devextreme/ui/data_grid";
import mdaeNotify, {
  NOTIFY_MESSAGE_TYPE,
} from "../../common_widgets/toast/notify";
import {
  downloadDocumentFromS3,
  previewDocumentFromS3,
} from "../../document-management/component";
import { bindActionCreators } from "redux";
import ArrayStore from "devextreme/data/array_store";
import { submitDocumentsToESMD } from "./component";
import { getDistinctStringsFromCommaSeperatedList } from "../../../pages/external-audit/esmd-dashboard";
const formatDataSourceBeforeExport = (esmdSubmissionList) => {
  for (var i = 0; i < esmdSubmissionList.length; i++) {
    esmdSubmissionList[i].cmsAcknowledgementDateStr = esmdSubmissionList[i]
      .cmsAcknowledgementDateStr
      ? format(
          new Date(esmdSubmissionList[i].cmsAcknowledgementDateStr),
          "MM/DD/YYYY HH:mm"
        )
      : null;
    esmdSubmissionList[i].reviewerAcknowledgementDateStr = esmdSubmissionList[i]
      .reviewerAcknowledgementDateStr
      ? format(
          new Date(esmdSubmissionList[i].reviewerAcknowledgementDateStr),
          "MM/DD/YYYY HH:mm"
        )
      : null;
    esmdSubmissionList[i].sentToCMSDateStr = esmdSubmissionList[i]
      .sentToCMSDateStr
      ? esmdSubmissionList[i].sentToCMSDateStr?.toLowerCase() === "pending"
        ? "Pending"
        : format(
            new Date(esmdSubmissionList[i].sentToCMSDateStr),
            "MM/DD/YYYY HH:mm"
          )
      : null;
    esmdSubmissionList[i].cmsRejectDateStr = esmdSubmissionList[i]
      .cmsRejectDateStr
      ? format(
          new Date(esmdSubmissionList[i].cmsRejectDateStr),
          "MM/DD/YYYY HH:mm"
        )
      : null;
    esmdSubmissionList[i].reviewerRejectDateStr = esmdSubmissionList[i]
      .reviewerRejectDateStr
      ? format(
          new Date(esmdSubmissionList[i].reviewerRejectDateStr),
          "MM/DD/YYYY HH:mm"
        )
      : null;
    esmdSubmissionList[i].roundSubmittedSequenceNos = parseInt(
      esmdSubmissionList[i].roundSubmittedSequenceNos
    );
  }
  return esmdSubmissionList;
};

const formatDocumentDetailBeforeExport = (esmdDocumentUploadList) => {
  for (let j = 0; j < esmdDocumentUploadList.length; j++) {
    let attachedLevelDisplayName = esmdDocumentUploadList[j].attachedLevelName;
    if (attachedLevelDisplayName?.toLowerCase() == "eac") {
      attachedLevelDisplayName = "PA Case";
    } else if (attachedLevelDisplayName?.toLowerCase() == "ea") {
      attachedLevelDisplayName = "Payer Audit";
    }
    esmdDocumentUploadList[
      j
    ].attachedLevelDisplayName = attachedLevelDisplayName;
    esmdDocumentUploadList[j].createDate = format(
      esmdDocumentUploadList[j].createDate,
      "MM/DD/YYYY HH:mm"
    );
    esmdDocumentUploadList[j].updateDate = format(
      esmdDocumentUploadList[j].updateDate,
      "MM/DD/YYYY HH:mm"
    );
  }
  return esmdDocumentUploadList;
};
const trackSubmissionParentColumnIndex = {
  0: "sentToCMSDateStr",
  1: "cmsAcknowledgementDateStr",
  2: "reviewerAcknowledgementDateStr",
  3: "cmsRejectDateStr",
  4: "reviewerRejectDateStr",
  5: "submissionStatus",
  6: "roundSubmittedSequenceNos",
  7: "documentCount",
  8: "documentUpdatedBy",
  9: "documentUpdateDate",
  10: "documentEaAuditId",
  11: "cmsTrackingNumbers",
};
const trackSubmissionParentColumns = {
  0: {
    header: "Sent to CMS",
    key: trackSubmissionParentColumnIndex[0],
    width: 40,
  },
  1: {
    header: "CMS Tracking ID",
    key: trackSubmissionParentColumnIndex[11],
    width: 50,
  },
  2: {
    header: "CMS Acknowledgement",
    key: trackSubmissionParentColumnIndex[1],
    width: 30,
  },
  3: {
    header: "Reviewer Acknowledgement",
    key: trackSubmissionParentColumnIndex[2],
    width: 30,
  },
  4: {
    header: "CMS Reject",
    key: trackSubmissionParentColumnIndex[3],
    width: 20,
  },
  5: {
    header: "Reviewer Reject",
    key: trackSubmissionParentColumnIndex[4],
    width: 20,
  },
  6: {
    header: "Comments",
    key: trackSubmissionParentColumnIndex[5],
    width: 50,
  },
  7: {
    header: "Round Submitted",
    key: trackSubmissionParentColumnIndex[6],
    width: 20,
  },
  8: {
    header: "Files Sent",
    key: trackSubmissionParentColumnIndex[7],
    width: 20,
  },
  9: {
    header: "",
    key: trackSubmissionParentColumnIndex[8],
    width: 20,
  },
  10: {
    header: "",
    key: trackSubmissionParentColumnIndex[9],
    width: 20,
  },
  11: {
    header: "",
    key: trackSubmissionParentColumnIndex[10],
    width: 20,
  },
};

const trackSubmissionChildDocumentColumns = {
  0: { parentKeyIndex: 0, key: "documentName", header: "File Name" },
  1: { parentKeyIndex: 1, key: "fileType", header: "File Type" },
  2: { parentKeyIndex: 2, key: "fileSizeDisplayName", header: "File Size" },
  3: { parentKeyIndex: 3, key: "documentCategoryName", header: "Category" },
  4: {
    parentKeyIndex: 4,
    key: "attachedLevelDisplayName",
    header: "Level",
  },
  5: { parentKeyIndex: 5, key: "attachedLevelTitle", header: "Level Name" },
  6: { parentKeyIndex: 6, key: "createdBy", header: "Uploaded By" },
  7: { parentKeyIndex: 7, key: "createDate", header: "Uploaded On" },
  8: { parentKeyIndex: 8, key: "updatedBy", header: "Updated By" },
  9: { parentKeyIndex: 9, key: "updateDate", header: "Updated On" },
  10: { parentKeyIndex: 10, key: "eaAuditId", header: "Audit Id" },
};
const trackSubmissionChildHeaderColumns = {
  0: { parentKeyIndex: 0, key: "requesterName", header: "Requester" },
  1: {
    parentKeyIndex: 1,
    key: "eaContentTypeDisplayName",
    header: "Content Type",
  },
  2: { parentKeyIndex: 2, key: "referenceId", header: "Reference ID" },
  3: {
    parentKeyIndex: 3,
    key: "rqstrRecordSubmissionMethodDisplayName",
    header: "Record Submission Method",
  },
  4: {
    parentKeyIndex: 4,
    key: "rqstrRecordSubmissionValue",
    header: "Review Contractor",
  },
  5: {
    parentKeyIndex: 5,
    key: "payerCaseId",
    header: "Payer Case/Claim ID",
  },
};

const getTrackSubmissionChildHeaderValues = (esmdDocumentUploadItem) => {
  return {
    requesterName: esmdDocumentUploadItem.eaRequesterName,
    submissionEaContentTypeId: esmdDocumentUploadItem.eaContentTypeId,
    eaContentTypeDisplayName:
      esmdDocumentUploadItem?.eaContentTypeCode +
      "-" +
      esmdDocumentUploadItem?.eaContentTypeDescription,
    referenceId: esmdDocumentUploadItem.referenceId,
    rqstrRecordSubmissionMethodDisplayName:
      esmdDocumentUploadItem.rqstrRecordSubmissionMethodDisplayName,
    rqstrRecordSubmissionValue: esmdDocumentUploadItem.reviewContractorCode,
    payerCaseId: esmdDocumentUploadItem.payerCaseId,
  };
};

const getFilteredDocumentList = async (component, esmdSubmissionList) => {
  const getDocumentList = async (esmdSubmissionListItem) => {
    return new Promise((resolve, reject) => {
      const detailDataGridInstance: any = DataGrid.getInstance(
        $(component.element()).find(
          "#" +
            trackSubmissionDetailDocumentDataGridIdPrefix +
            esmdSubmissionListItem.esmdDocumentUploadId
        ) as any
      );
      const store = new ArrayStore({
        data: esmdSubmissionListItem.esmdDocumentUploadList,
      });
      store
        .load({ filter: detailDataGridInstance.getCombinedFilter() })
        .then(function(result) {
          resolve(result);
        });
    });
  };
  return new Promise(async (resolve, reject) => {
    for (let i = 0; i < esmdSubmissionList.length; i++) {
      const documentList = await getDocumentList(esmdSubmissionList[i]);
      esmdSubmissionList[i].esmdDocumentUploadList = documentList;
    }
    resolve(esmdSubmissionList);
  });
};
const exportEsmdSubmissionListToExcel = (e) => {
  e.component.beginCustomLoading("Exporting Data");
  e.cancel = true;
  const esmdSubmissionListDataSource = e.component.getDataSource();
  var loadOptions: any = { filter: e.component.getCombinedFilter() };
  var sortColumns = e.component.option("columns")?.filter((x) => x.sortOrder);
  if (sortColumns && sortColumns.length) {
    loadOptions.sort = [];
    sortColumns.map((item) => {
      loadOptions.sort.push({
        selector: sortColumns[0].dataField,
        desc: item.sortOrder?.toLowerCase() === "desc",
        asc: item.sortOrder?.toLowerCase() === "asc",
      });
    });
  }
  esmdSubmissionListDataSource
    ?.store()
    .load(loadOptions)
    .done((result) => {
      let esmdSubmissionList = formatDataSourceBeforeExport(cloneDeep(result));
      if (esmdSubmissionList.length > 0) {
        esmdSubmissionList.map((item) => {
          e.component.expandRow(item.esmdDocumentUploadId);
        });

        setTimeout(async () => {
          esmdSubmissionList = await getFilteredDocumentList(
            e.component,
            esmdSubmissionList
          );
          const workbook = new ExcelJS.Workbook();

          for (var i = 0; i < esmdSubmissionList.length; i++) {
            const worksheet = workbook.addWorksheet("Submission " + (i + 1));

            var tempColumns = [];
            for (let prop in trackSubmissionParentColumns) {
              tempColumns.push(trackSubmissionParentColumns[prop]);
            }
            worksheet.columns = tempColumns;
            worksheet.addRow(esmdSubmissionList[i]);
            worksheet.addRow({});
            worksheet.addRow({});

            var tempItem = {};
            for (let prop in trackSubmissionChildHeaderColumns) {
              tempItem[trackSubmissionParentColumnIndex[prop]] =
                trackSubmissionChildHeaderColumns[prop].header;
            }

            worksheet.addRow(tempItem);
            const headerValueItem = getTrackSubmissionChildHeaderValues(
              esmdSubmissionList[i]
            );
            tempItem = {};
            for (let prop in trackSubmissionChildHeaderColumns) {
              tempItem[
                trackSubmissionParentColumnIndex[
                  trackSubmissionChildHeaderColumns[prop].parentKeyIndex
                ]
              ] = headerValueItem[trackSubmissionChildHeaderColumns[prop].key];
            }
            worksheet.addRow(tempItem);
            worksheet.addRow({});
            worksheet.addRow({});

            let esmdDocumentUploadList =
              esmdSubmissionList[i].esmdDocumentUploadList;
            if (esmdDocumentUploadList && esmdDocumentUploadList.length > 0) {
              esmdDocumentUploadList = formatDocumentDetailBeforeExport(
                esmdDocumentUploadList
              );
              worksheet.addRow({ sentToCMSDateStr: "Submitted Documents:" });

              tempItem = {};
              for (let prop in trackSubmissionChildDocumentColumns) {
                tempItem[
                  trackSubmissionParentColumnIndex[
                    trackSubmissionChildDocumentColumns[prop].parentKeyIndex
                  ]
                ] = trackSubmissionChildDocumentColumns[prop].header;
              }

              worksheet.addRow(tempItem);
              tempItem = {};
              for (let j = 0; j < esmdDocumentUploadList.length; j++) {
                tempItem = {};
                for (let prop in trackSubmissionChildDocumentColumns) {
                  tempItem[
                    trackSubmissionParentColumnIndex[
                      trackSubmissionChildDocumentColumns[prop].parentKeyIndex
                    ]
                  ] =
                    esmdDocumentUploadList[j][
                      trackSubmissionChildDocumentColumns[prop].key
                    ];
                }
                worksheet.addRow(tempItem);
              }
            }
          }

          esmdSubmissionList.map((item) => {
            e.component.collapseRow(item.esmdDocumentUploadId);
          });
          workbook.xlsx
            .writeBuffer()
            .then((buffer) => {
              FileSaver.saveAs(
                new Blob([buffer], { type: "application/octet-stream" }),
                "EsMdTrackSubmissionList.xlsx"
              );
              e.component.endCustomLoading();
            })
            .catch((err) => {
              console.log(err.message);
            });
        }, 1000);
      } else {
        mdaeNotify({
          message: "No data found.",
          messageType: NOTIFY_MESSAGE_TYPE.ERROR,
        });
      }
    });
};
const EsmdTrackSubmissionDetailComponent: React.FC<any> = (props) => {
  const dispatch = useDispatch();
  const asyncAction = bindActionCreators(
    {
      asyncOperationStart: asyncActions.asyncOperationStart,
    },
    dispatch
  );
  const datagridOptions = getEsmdSubmissionTrackingDetailDataGridOption(
    props.data?.data?.esmdDocumentUploadList,
    props.data.data.esmdDocumentUploadId,
    dispatch,
    asyncAction
  );
  return (
    <div>
      <AuditPropertiesSection
        isFromTrackSubmissionTab={true}
        submittedDocumentHeaderData={props.data?.data}
      ></AuditPropertiesSection>
      <div className="track-submission-detail-document-datagrid">
        <div className="submitted-documents-label">Submitted Documents:</div>
      </div>
      <MdaeDataGrid {...datagridOptions}></MdaeDataGrid>
    </div>
  );
};
const TrackEsmdSubmissionTab: React.FC<any> = (props) => {
  const dispatch = useDispatch();
  const asyncAction = bindActionCreators(
    {
      asyncOperationStart: asyncActions.asyncOperationStart,
    },
    dispatch
  );
  const esmdSubmissionList = useSelector(
    (state) => state["esmdSubmissionReducer"].esmdSubmissionList,
    isEqual
  );
  const selectedEsmdDocumentUploadId = useSelector(
    (state) => state["esmdSubmissionReducer"].selectedEsmdDocumentUploadId,
    isEqual
  );
  const completeCaseDetail = useSelector(
    (state) => state["caseDetailReducer"].completeCaseDetail
  );
  const caseDetailData = useSelector(
    (state) => state["caseDetailReducer"].caseDetailData
  );
  const caseData = useSelector(
    (state) => state["caseDataReducer"].caseData
  );
  const selectedNpi = useSelector(
    (state) => state["esmdSubmissionReducer"].selectedNpi
  );

  const onEsmdSubmissionListDataGridContentReady = (e) => {
    const queryParams = new URLSearchParams(window.location.search);
    const visibleRows = e.component?.getVisibleRows();
    if (
      visibleRows.length > 0 &&
      esmdSubmissionList.length > 0 &&
      selectedEsmdDocumentUploadId > 0 &&
      queryParams.has("esmddocumentuploadid")
    ) {
      e.component.navigateToRow(selectedEsmdDocumentUploadId);
      e.component.expandRow(selectedEsmdDocumentUploadId);

      if (queryParams.has("eacaseid")) {
        queryParams.delete("eacaseid");
      }
      if (queryParams.has("esmddocumentuploadid")) {
        queryParams.delete("esmddocumentuploadid");
      }
      props.history.replace({
        search: queryParams.toString(),
      });
      setTimeout(() => {
        e.component.navigateToRow(selectedEsmdDocumentUploadId);
      }, 3000);
    }
  };
  const retrySubmission = useCallback(
    (data) => {
      let npi = selectedNpi;
      submitDocumentsToESMD(
        asyncAction,
        dispatch,
        { npi, payerClaimControlNo: caseData?.payerClaimControlNo, ...data },
        completeCaseDetail,
        caseDetailData,
        true
      );
    },
    [completeCaseDetail, caseDetailData, caseData?.payerClaimControlNo, selectedNpi]
  );

  const esmdSubmissionListDataGridOptions = useMemo(() => {
    return getEsmdSubmissionTrackingGridOption(
      esmdSubmissionList,
      onEsmdSubmissionListDataGridContentReady,
      exportEsmdSubmissionListToExcel,
      retrySubmission
    );
  }, [esmdSubmissionList]);

  return (
    <div>
      <MdaeDataGrid {...esmdSubmissionListDataGridOptions}>
        <MasterDetail
          enabled={true}
          render={(e) => {
            return (
              <EsmdTrackSubmissionDetailComponent
                data={e}
              ></EsmdTrackSubmissionDetailComponent>
            );
          }}
        ></MasterDetail>
      </MdaeDataGrid>
    </div>
  );
};

const getEsmdSubmissionTrackingGridOption = (
  esmdSubmissionList: any[],
  onEsmdSubmissionListDataGridContentReady,
  exportEsmdSubmissionListToExcel,
  retrySubmission
) => {
  const documentListDataGridOptions: IMdaeDataGridProps = {
    id: "grdEsmdTrackSumissionDocumentList",
    allowColumnResizing: true,
    keyExpr: "esmdDocumentUploadId",
    stateStoring: {
      enabled: true,
      storageKey: "grd-esmd-track-sumission-document-list-state-storage-key_v1",
      type: "localStorage",
    },
    export: { enabled: true, fileName: "EsMdDocumentList" },
    mdaeColumnChooser: { isMdaeColumnChooserVisible: true },
    mdaeSearchPanel: { visible: true },
    onExporting: exportEsmdSubmissionListToExcel,
    clearFilterButtonId: "btn-esmd-track-submission-grid-clear-filter",
    dataSource: esmdSubmissionList,
    onContentReady: (e) => {
      $(e.element)
        .find(".dx-master-detail-cell")
        .css("background-color", "white");
      onEsmdSubmissionListDataGridContentReady(e);
    },
    filterRow: { visible: true },
    headerFilter: { visible: true },
    pageSize: 10,
    loadPanel: {
      enabled: true,
    },
    mdaeColumns: [
      {
        fixed: true,
        allowSorting: false,
        allowFiltering: false,
        allowGrouping: false,
        allowResizing: false,
        allowReordering: false,
        allowHiding: false,
        allowExporting: false,
        dataField: "esmdDocumentUploadId",
        caption: "",
        alignment: "center",
        width: 50,
        visible: false,
      },
      {
        dataField: "sentToCMSDateStr",
        caption: "Sent To CMS",
        dataType: "date",
        format: "MM/dd/yyyy HH:mm",
        allowFiltering: true,
        allowSorting: true,
        fixed: true,
        width: 120,
        calculateSortValue: (e) => {
          return new Date(e.sentToCMSDate);
        },
      },
      {
        dataField: "cmsTrackingNumbers",
        caption: "CMS Tracking ID",
        width: 130,
        cellRender(e) {
          let trackingNumberString = getDistinctStringsFromCommaSeperatedList(
            e.data.cmsTrackingNumbers
          );
          return <div title={trackingNumberString}>{trackingNumberString}</div>;
        },
      },
      {
        dataField: "cmsAcknowledgementDateStr",
        caption: "CMS Acknowledgement",
        dataType: "date",
        format: "MM/dd/yyyy HH:mm",
        allowFiltering: true,
        allowSorting: true,
        width: 150,
      },
      {
        dataField: "reviewerAcknowledgementDateStr",
        caption: "Reviewer Acknowledgement",
        dataType: "date",
        format: "MM/dd/yyyy HH:mm",
        allowFiltering: true,
        allowSorting: true,
        width: 150,
      },
      {
        dataField: "cmsRejectDateStr",
        caption: "CMS Reject",
        dataType: "date",
        format: "MM/dd/yyyy HH:mm",
        allowFiltering: true,
        allowSorting: true,
        width: 150,
      },
      {
        dataField: "reviewerRejectDateStr",
        caption: "Reviewer Reject",
        allowFiltering: true,
        dataType: "date",
        format: "MM/dd/yyyy HH:mm",
        allowSorting: true,
        width: 150,
      },
      {
        dataField: "comments",
        caption: "Comments",
        allowFiltering: true,
        allowSorting: true,
        width: 250,
      },
      {
        dataField: "roundSubmittedSequenceNos",
        caption: "Round Submitted",
        allowFiltering: true,
        allowSorting: true,
        width: 150,
        cellRender: esmdRoundSubmittedCellRender,
      },
      {
        dataField: "npi",
        caption: "NPI",
        allowFiltering: true,
        allowSorting: true,
        width: 120,
      },
      {
        dataField: "documentCount",
        caption: "Files Sent",
        allowFiltering: true,
        allowSorting: true,
        sortOrder: "desc",
        width: 80,
      },
    ],
  };
  const isFailedSubmissionPresent = esmdSubmissionList.some(x => x.isSubmissionFailedAfterTimeout);
  if (isFailedSubmissionPresent) {
    documentListDataGridOptions.mdaeColumns.push({
      showInColumnChooser: false,
      fixed: true,
      allowSorting: false,
      allowFiltering: false,
      allowGrouping: false,
      allowResizing: false,
      allowReordering: false,
      allowHiding: false,
      allowExporting: false,
      cellRender: (e) => {
        if (e.data.isSubmissionFailedAfterTimeout)
          return (
            <div
              onClick={() => {
                let data = {
                  esmdDocumentUploadId: e.data.esmdDocumentUploadId,
                };
                retrySubmission(data);
              }}
              style={{ height: "14px", color: "red", cursor: "pointer" }}
              className={"dx-icon-pulldown"}
              title={"Click here to resubmit"}
            ></div>
          );
        else return <></>;
      },
      alignment: "center",
      width: 50,
    });
  }
  return documentListDataGridOptions;
};
const trackSubmissionDetailDocumentDataGridIdPrefix =
  "grdEsdmSubmissionTrackingDetailGrid";
const getEsmdSubmissionTrackingDetailDataGridOption = (
  submittedDocumentList,
  esmdDocumentUploadId,
  dispatch,
  asyncAction
) => {
  const documentListDataGridOptions: IMdaeDataGridProps = {
    id: trackSubmissionDetailDocumentDataGridIdPrefix + esmdDocumentUploadId,
    allowColumnResizing: true,
    allowColumnReordering: true,
    mdaeColumnChooser: { isMdaeColumnChooserVisible: true },
    mdaeSearchPanel: { visible: true },
    stateStoring: {
      enabled: true,
      storageKey:
        "grd-esmd-track-sumission-document-detail-list-state-storage-key-v3",
      type: "localStorage",
    },
    clearFilterButtonId:
      "btn-esmd-submission-tracking-detail-grid-clear-filter",
    dataSource: submittedDocumentList,
    filterRow: { visible: true },
    headerFilter: { visible: true },
    pageSize: 10,
    scrolling: {
      columnRenderingMode: "virtual",
    },
    mdaeColumns: [
      {
        fixed: true,
        allowSorting: false,
        allowFiltering: false,
        allowGrouping: false,
        allowResizing: false,
        allowReordering: false,
        allowHiding: false,
        allowExporting: false,
        dataField: "documentId",
        caption: "",
        alignment: "center",
        width: 50,
        cellRender: (e) => {
          return (
            <div>
              {e.data.fileType?.toLowerCase() === "pdf" && (
                <div
                  onClick={() => {
                    previewDocumentFromS3(
                      dispatch,
                      asyncAction,
                      e.data.s3ObjectName,
                      e.data.documentName,
                      e.data.originalFileName,
                      e.data.documentId,
                      e.data.attachedLevelId,
                      e.data.attachedLevelName
                    );
                  }}
                  style={{ height: "14px" }}
                  className={"preview-action-icon"}
                  title={"Preview"}
                ></div>
              )}
              {e.data.fileType?.toLowerCase() !== "pdf" && (
                <div
                  style={{ height: "16px" }}
                  className={
                    "download-icon mdae-datagrid-action-menu-item-icon"
                  }
                  title={"Download"}
                  onClick={() => {
                    downloadDocumentFromS3(
                      dispatch,
                      asyncAction,
                      e.data.s3ObjectName,
                      e.data.documentName,
                      e.data.originalFileName,
                      e.data.documentId,
                      e.data.attachedLevelId,
                      e.data.attachedLevelName
                    );
                  }}
                >
                  Download
                </div>
              )}
            </div>
          );
        },
      },
      {
        dataField: "documentName",
        caption: "File Name",
        allowFiltering: true,
        allowSorting: true,
        fixed: false,
        allowHiding: false,
        width: 300,
      },
      {
        dataField: "fileType",
        caption: "File Type",
        allowFiltering: true,
        allowSorting: true,
        width: 80,
      },
      {
        dataField: "fileSizeDisplayName",
        calculateSortValue: "fileSize",
        caption: "File Size",
        width: 80,
        allowFiltering: false,
        allowSorting: true,
        alignment: "right",
      },
      {
        dataField: "documentCategoryName",
        caption: "Category",
        allowFiltering: true,
        allowSorting: true,
        width: 200,
      },
      {
        dataField: "attachedLevelDisplayName",
        caption: "Level",
        allowFiltering: true,
        allowSorting: true,
        width: 100,
      },
      {
        dataField: "attachedLevelTitle",
        caption: "Level Name",
        allowFiltering: true,
        allowSorting: true,
        width: 250,
      },
      {
        dataField: "eaAuditId",
        caption: "Audit ID",
        visible: false,
        allowFiltering: true,
        allowSorting: true,
        width: 100,
      },
      {
        dataField: "createdBy",
        caption: "Uploaded By",
        allowFiltering: true,
        allowSorting: true,
        width: 150,
      },
      {
        dataField: "createDate",
        caption: "Uploaded On",
        dataType: "date",
        format: "MM/dd/yyyy HH:mm",
        allowFiltering: true,
        allowSorting: true,

        width: 120,
      },
      {
        dataField: "updatedBy",
        caption: "Updated By",
        allowFiltering: true,
        allowSorting: true,
        width: 150,
      },
      {
        dataField: "updateDate",
        caption: "Updated On",
        dataType: "date",
        format: "MM/dd/yyyy HH:mm",
        allowFiltering: true,
        allowSorting: true,
        sortOrder: "desc",
        width: 120,
      },
    ],
  };
  return documentListDataGridOptions;
};

const enhance = compose(withRouter);

export default enhance(TrackEsmdSubmissionTab);
